import dayjs from 'utils/dayjsConfig';

import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const specialOrdersApi = {
    cancelSpecialOrder: async (id) => {
        const url = `api/order/v1/special/${id}/cancel`;
        try {
            const response = await mmFetch(url, { method: 'PUT' });
            if (response.ok === true) {
                return true;
            }
            return false;
        } catch (e) {
            console.log('[cancelSpecialOrder] error', e.toString());
            return false;
        }
    },
    createSpecialOrder: async (sendParams) => {
        const url = `api/order/v1/special`;
        try {
            return mmFetchWithResponse(url, {
                method: 'POST',
                body: JSON.stringify(sendParams),
            });
        } catch (e) {
            console.log('[createSpecialOrder] error', e.toString());
            return false;
        }
    },
    downloadPDF: async (id) => {
        const url = `api/order/v1/special/${id}/pdf`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = `special-order-${id}.pdf`;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadPDF] error', e.toString());
        }
    },
    getSpecialOrders: async (status) => {
        const url = `api/order/v1/special?status=${status}`;
        try {
            let response = await mmFetch(url);
            if (response.ok === true) {
                response = await response.json();
                return response.data.orders.map((item) => {
                    const newItem = { ...item };
                    newItem.createdAt = dayjs(newItem.createdAt.date).format('MM/DD/YYYY');
                    newItem.shipDate = dayjs(newItem.shipDate.date).format('MM/DD/YYYY');
                    return newItem;
                });
            }
            return [];
        } catch (e) {
            console.log('[getSpecialOrders] error', e.toString());
            return [];
        }
    },
    markShipped: async (id) => {
        const url = `api/order/v1/special/${id}/ship`;
        try {
            const response = await mmFetch(url, { method: 'PUT' });
            if (response.ok === true) {
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    },
    purchaseLabel: async (id) => {
        const url = `api/order/v1/special/${id}/purchase`;
        try {
            const response = await mmFetch(url, { method: 'POST' });
            if (response.ok === true) {
                return true;
            }
            return false;
        } catch (e) {
            console.log('[purchaseLabel] error', e.toString());
            return false;
        }
    },
    updateSpecialOrder: async ({ field, id, value }) => {
        const sendParams = field === 'address' ? value : { [field]: value };
        const url = `api/order/v1/special/${id}/update`;
        try {
            await mmFetch(url, {
                method: 'PUT',
                body: JSON.stringify(sendParams),
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return true;
        } catch (e) {
            console.log('[updateSpecialOrder] error', e.toString());
            return false;
        }
    },
};

export { specialOrdersApi };
